function BrisHack() {
    return (<div>
        For this years theme of "health", my team created a webapp which created spotify playlists for running. You could log in using spotify and select a route length and speed. It created a route for you and a playlist to match the speed you wanted to run at. The app was built using React and Flask and we ended up winning the "Best Software" category.
        <iframe className="mx-auto aspect-video h-full w-full" title="spotify app video" width="720" height="520" src="https://www.youtube.com/embed/9MRcfe_n8jI?si=39xID-v2Ct2-cmR9" />
    </div>);
}

export default BrisHack;